import React, { useState, useRef, useEffect } from "react";
// import "codemirror/lib/codemirror.css";
import CodeMirror from "@uiw/react-codemirror";
import { okaidia } from "@uiw/codemirror-theme-okaidia";
import { undoDepth, redoDepth } from "@codemirror/commands";
import { linter, lintGutter, forEachDiagnostic } from "@codemirror/lint";
import prettier from "prettier/standalone";
import parserhtml from "prettier/parser-html";
import { HTMLHint } from "htmlhint";
import { html } from "@codemirror/lang-html";

const HtmlComponent = ({
  editor,
  setHTMLCodeEditor,
  checkErrors,
  setcheckErrors,
  defaultActiveTab,
  setUndoAvailable,
  setRedoAvailable,
}) => {
  const [code, setCode] = useState("");
  const HtmlRef = useRef();

  useEffect(() => {
    let FormattedCode = prettier.formatWithCursor(editor.getHtml(), {
      parser: "html",
      plugins: [parserhtml],
      tabWidth: 4,
      useTabs: false,
      //cursorOffset: editor.indexFromPos(editor.getCursor()),
    });
    setCode(FormattedCode.formatted);
    setHTMLCodeEditor(HtmlRef);

   
  }, []);

  useEffect(()=>{
    if(defaultActiveTab !== "HTML") {
      setCode("");
    } else {
    let FormattedCode = prettier.formatWithCursor(editor.getHtml(), {
      parser: "html",
      plugins: [parserhtml],
      tabWidth: 4,
      useTabs: false,
    });
    setCode(FormattedCode.formatted);
    setHTMLCodeEditor(HtmlRef);
  }
  },[defaultActiveTab]);

  const handleErrors = (errorList, from, to) => {
    // console.log(errorList.severity);
    let error =
      errorList.severity === "error"
        ? setcheckErrors({ ...checkErrors, html: true })
        : "";
  };

  useEffect(() => {
    if (!HtmlRef.current.view) return;
    forEachDiagnostic(HtmlRef.current?.view?.viewState?.state, handleErrors);

    const undoDepthCount = undoDepth(HtmlRef.current?.view?.state);
    setUndoAvailable(undoDepthCount>0);
    const redoDepthCount = redoDepth(HtmlRef.current?.view?.state);
    setRedoAvailable(redoDepthCount>0);
  }, [code]);
  // const iframeDocument = editor?.Canvas?.getDocument(); // Access the iframe document
  
  // // // Disable keyboard copy (Ctrl + C or Cmd + C)
  // iframeDocument.addEventListener('keydown', (e) => {
  //   // Prevent copy (Ctrl + C or Cmd + C)
  
  //   let FormattedCode = prettier.formatWithCursor(editor.getHtml(), {
  //     parser: "html",
  //     plugins: [parserhtml],
  //     tabWidth: 4,
  //     useTabs: false,
  //     //cursorOffset: editor.indexFromPos(editor.getCursor()),
  //   });
  //   setCode(FormattedCode.formatted);


  // });

  var options = {
    autoCloseTags: true,
    autoCloseBrackets: true,
    lineWrapping: true,
    styleActiveLine: true,
    smartIndent: true,
    indentWithTabs: true,
    autoBeautify: true,
  };
  var config = {
    matchClosingTags: true,
    selfClosingTags: true,
    autoCloseTags: true,
  };

  const htmlLinterExtension = linter((view) => {
    var rulesets = {
      "doctype-first": false,
      "tags-check": true,
      "tag-pair": true,
      "tag-self-close": false,
      "tagname-lowercase": true,
      "tagname-specialchars": true,
      "empty-tag-not-self-closed": true,
      "src-not-empty": true,
      "href-abs-or-rel": false,
      "attr-no-duplication": true,
      "id-unique": true,
      "title-require": true,
    };
    var warrningList = ["empty-tag-not-self-closed", "tags-check"];
    var errorList = [];
    var messages =
      HTMLHint.verify(
        HtmlRef.current.view.viewState.state.doc.toString(),
        rulesets
      ) || [];

    messages.forEach((message) => {
      let Line =
        HtmlRef.current.view.viewState.state.doc.line(message.line).from +
        message.col;

      let charLocation = HtmlRef.current.view.viewState.state.doc.lineAt(Line);
      // let error =
      //   message.type === "error"
      //     ? setcheckErrors({ ...checkErrors, html: true })
      //     : "";

      errorList.push({
        from: charLocation.from,
        to: charLocation.from,
        message: message.message,
        severity:
          warrningList.indexOf(message.rule.id) > -1 ? "warning" : message.type,
      });
    });

    return errorList;
  }, {});

 useEffect(()=>{
  editor.on("storage:end:store", () => {
    let FormattedCode = prettier.formatWithCursor(editor.getHtml(), {
      parser: "html",
      plugins: [parserhtml],
      tabWidth: 4,
      useTabs: false,
      //cursorOffset: editor.indexFromPos(editor.getCursor()),
    });
    setCode(FormattedCode.formatted);
   })
 })
 /* editor.on("component:selected", (component) => { 
    
  let htmlstring=component.getEl().outerHTML;
  let FormattedCode = prettier.formatWithCursor(htmlstring, {
    parser: "html",
    plugins: [parserhtml],
    tabWidth: 4,
    useTabs: false,
    //cursorOffset: editor.indexFromPos(editor.getCursor()),
  });
  setCode(FormattedCode.formatted);
  
}) */ 
  return (
    <div>
      <CodeMirror
        height="calc(100vh - 106px)"
        ref={HtmlRef}
        value={code}
        extensions={[html(), lintGutter(), htmlLinterExtension]}
        theme={okaidia}
        // onBeforeChange={(editor, data, code) => {
        //   setCode({ code });
        // }}
        onChange={(updatedCode) => {
          setCode(updatedCode);
        }}
        options={options}
      />
    </div>
  );
};
export default HtmlComponent;
